import * as React from "react";
import ContentManagerHandleData from "./ContentManagerHandleData";

export const ContentManagerContent: React.FC = () => (
  <div className="h-full pt-4 px-6 pb-0 font-sans w-full border-1 border-black rounded-lg bg-white box-border">
    <div className="flex justify-between items-center w-full mb-4">
      <h1 className="text-2xl font-bold text-[#092a45]">Content Manager</h1>
      <img src="assets/AlphaScript_Logo_Dark_cropped.png" alt="" className="w-30 h-auto object-contain" />
    </div>
    <div className="w-full">
      <ContentManagerHandleData />
    </div>
  </div>
);
